import {createFlexAtom} from './utils';

const config = createFlexAtom('row');

export default config;
